const API_URL = {
  ucas: "hewebsites/v1/homepage/ucas-ajax", //POST
  ucasGuest: "hewebsites/v1/guest/homepage/ucas-ajax", //POST
  homePageReviews: "hewebsites/v1/homepage/reviews", //POST
  guestuserRegistration: "/hewebsites/v1/guest/users/registration", //POST
  newsletterYearOfEntry: "hewebsites/v1/users/options", //GET
  updateUcas: "hewebsites/v1/homepage/update-ucas", //POST
  subjectAjax: "/hewebsites/v1/homepage/sub-inst-ajax", //GET
  srPage: "/dom-search/v1/search/searchResults", //POST
  srPrFilterPath: "dom-search/v1/search/getSearchFilters", //POST
  getEnquiryDetails: "dom-search/v1/search/getEnquiryDetails", //POST
  srDisplayNameEndPt: "/hewebsites/v1/seo/search-display-names", //POST
  userRegion: "dom-search/v1/search/getRegionDetails", //GET
  profileTab: "/hewebsites/v1/institution/profile-tab", //GET
  cpcUniversities: "/dom-search/v1/cpc/universities", //POST
  cpcCourses: "/dom-search/v1/cpc/courses", //POST
  cpcRegions: "/dom-search/v1/cpc/regions", //POST
  cpcSubjects: "/dom-search/v1/cpc/subjects", //POST
  cpcOpenDays: "/dom-search/v1/cpc/openDays", //POST
  logErrors: "/hewebsites/v1/logs/error-log", //POST
  otherRecommendedCourse: "/hewebsites/v1/recommended/recom-course", //POST
  clickstreamForGuest: "/hewebsites/v1/guest/logs/clickstream", //POST
  clickstreamForUser: "/hewebsites/v1/logs/clickstream", //POST
  userRegistration: "/hewebsites/v1/users/registration", //POST
  getUserFavourites: "/hewebsites/v1/favourites/get-favourite", //POST
  getGuestFavourites: "/hewebsites/v1/guest/homepage/get-favourite", //POST
  addRemoveUserFavourites: "/hewebsites/v1/favourites/favorites-add-delete", //POST
  addRemoveGuestFavourites:
    "/hewebsites/v1/guest/homepage/favourites-add-update", //POST
  getPostcode: "/dom-search/v1/search/getPostcode", //POST
  reviewDetails: "/dom-search/v1/reviews/detail", //POST
  Chanceofacceptancebar: "/dom-search/v1/search/chanceOfAcceptance", //POST
  ChanceofacceptancebarGuest: "/dom-search/v1/guest/chanceOfAcceptance", //POST
  cdpage: "/dom-search/v1/search/", //GET
  prPage: "/dom-search/v1/search/providerResults", //POST
  tickerTape: "/hewebsites/v1/homepage/ticker-tape",
  clearingUniversity: "/dom-search/v1/clearing/institutionProfile", //POST
  clearingSubjectAjax: "/dom-search/v1/clearing/subjectAjax",
  clearingEliteSection: "/dom-search/v1/search/featured-providers",
  clearingUniAjax: "/dom-search/v1/clearing/institutionAjax",
  veppleTakeATour: "/hewebsites/v1/homepage/veppleDetails", //GET
  inYearInstitutionProfile: "/hewebsites/v1/institution/details",
  costOfLivingPodDetails: "/hewebsites/v1/colc/colcPod",
  mapBoxDetails: "/hewebsites/v1/institution/mapbox",
  subjectProfile: "/hewebsites/v1/institution/subjectProfile",
  scholarshipFilterPath: "/dom-search/v1/search/getScholarshipFilter",
  scholarshipLandingBFF: "/dom-search/v1/search/getScholarshipResult",
  scholarshipDisplayName: "/hewebsites/v1/seo/search-display-names",
  scholarshipDetailsBFF: "/dom-search/v1/scholarship/",
  universityAndSubjectAjax: "/dom-search/v1/search/getScholarshipAjax",
  scholarshipFilterCount: "/dom-search/v1/search/getScholarshipCount",
  scholarshipFeaturedDetails: "/dom-search/v1/scholarship/featuredScholarship",
  similarAndPopularScholarship:
    "/dom-search/v1/scholarship/featuredScholarship",
  universityReviewDetails: "/hewebsites/v1/institution/reviewDetails",
  universityReviews: "/hewebsites/v1/institution/reviews",
  helpfulReview: "/hewebsites/v1/reviews/helpful/",
  reviewHelpfulDetails: "/hewebsites/v1/reviews/helpful/data",
  reviewSubjects: "/hewebsites/v1/institution/reviewSubjects",
  findUniversity: "dom-search/v1/search/findUniversity", //POST
  resolveWebclick: "dom-search/v1/search/getInstitutionCpeDetails", //POST
  destinationsUniversities: "/hewebsites/v1/destinations/discover-universities", //GET
  destinationOpendays: "/hewebsites/v1/destinations/discover-universities", //GET
};
export default API_URL;
